module.exports = __webpack_public_path__ + "assets/img/modal-avatar-1d0460fc.png";